import { render, staticRenderFns } from "./AiElasticChatModal.vue?vue&type=template&id=81c79150&scoped=true"
import script from "./AiElasticChatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AiElasticChatModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c79150",
  null
  
)

export default component.exports